import state from './state'
import getters from './getters'
import * as mutations from './mutations'
import actions from './actions'

export default {
  namespaced: true,
  state,
  getters:getters,
  mutations,
  actions:actions
}
